import { Router } from "@angular/router";
import { MenueCatList } from "./../../../modals/menue-cat-list";
import { MenueList } from "./../../../modals/menue-list";
import { EnumService } from "./../services/enum.service";
import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.sass"],
})
export class MenuComponent implements OnInit {
  constructor(
    private enumService: EnumService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }
  // menu: MenueList;
  menu: any[] = [];
  subMenu: any[] = [];
  menuCat: MenueCatList[] = [];
  ngOnInit() {
    this.getMenu();
  }
  openMegaMenu() {
    //#region descomentar
    let pane = document.getElementsByClassName("cdk-overlay-pane");
    [].forEach.call(pane, function (el) {
      if (el.children.length > 0) {
        if (el.children[0].classList.contains("mega-menu")) {
          el.classList.add("mega-menu-pane");
        }
      }
    });
    //#endregion
    // alert("por el momento no disponible");
  }
  getMenu() {
    this.enumService.getMenu("cat").subscribe((res: any) => {
      console.log(res);
      if (res.length == 0) {
        this.menu = [];
      } else {
        res.forEach((el) => {
          this.menu.push({
            categoryGroupName: el.TituloMenuE,
            itemMenu: el.menusECat_List,
            IconMenuE: el.IconMenuE,
          });
          //el.menusECat_List.forEach(el2 => {});
        });
        // console.log(this.menu)
      }
    });
  }
  irCategoria(Categoria) {
    if (sessionStorage.getItem("paramFilter") != null) {
      let paramNomItem = {
        param1: "",
        param2: "",
        param3: "",
      };
      sessionStorage.setItem("paramFilter", JSON.stringify(paramNomItem));
    }
    sessionStorage.setItem("marca", "TODAS");
    this.router.navigate([
      "/home/products",
      Categoria.Codigo,
      0,
      0,
      "TODAS",
      0,
      0,
      1,
    ]);
    this.enumService.setTitleMeta(Categoria.DenoCat + " | Novaplaza", {
      name: "description",
      content:
        "Ofrecemos las mejores " +
        Categoria.DenoCat +
        " al mejor precio en Arequipa",
    });
  }
  irANuestrasTiendas() {
    let url = String(window.location);
    if (!url.includes("pages/contact")) {
      this.spinner.show();
      this.router.navigate(["/pages/contact"]);
      this.enumService.setTitleMeta("Novaplaza | Tecnología de nivel", {
        name: "description",
        content:
          "Ofrecemos la más grande variedad de Laptops, Computadoras, Impresoras,Tablets, Accesorios, Zona Gamer, Software, Equipos de Bioseguridad,Herramientas para trabajar y estudiar en casa.",
      });
    }
  }
  verMasTiendas() {
    this.router.navigate(["/home/products", 0, 0, 0, "TODAS", 0, 0, 1], {
      queryParams: { Tienda: 0 },
    });
    this.enumService.setTitleMeta("Novaplaza | Tiendas", {
      name: "description",
      content:
        "Ofrecemos la más grande variedad de Laptops, Computadoras, Impresoras,Tablets, Accesorios, Zona Gamer, Software, Equipos de Bioseguridad,Herramientas para trabajar y estudiar en casa.",
    });
  }
  selectItem(item) {
    this.subMenu = item.itemMenu
  }
}
